import { Flex, type FlexProps } from "@mantine/core";
import React from "react";

import styles from "./MultipleAttachments.module.scss";

export const StyledFileFlex: React.FC<FlexProps> = ({
  className,
  ...props
}) => (
  <Flex className={`${styles.styledFileFlex} ${className ?? ""}`} {...props} />
);
